"use client";
import { type VariantProps, cva } from "class-variance-authority";
import type React from "react";
import { cn } from "../lib/utils";

const codeVariants = cva(
  "flex w-full px-4 border rounded-xl ring-0 flex items-start justify-between ph-no-capture whitespace-pre-wrap break-all ",
  {
    variants: {
      variant: {
        default: "focus:outline-hidden focus:ring-0 bg-gray-3 text-2xs py-2",
        ghost: "border-none bg-transparent text-2xs py-2",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface CodeProps
  extends React.HTMLAttributes<HTMLPreElement>,
    VariantProps<typeof codeVariants> {
  className?: string;
  buttonsClassName?: string;
  preClassName?: string;
  variant?: "default" | "ghost";
  copyButton?: React.ReactNode;
  visibleButton?: React.ReactNode;
}

function Code({
  className,
  variant,
  copyButton,
  visibleButton,
  buttonsClassName,
  preClassName,
  ...props
}: CodeProps) {
  return (
    <div className={cn(codeVariants({ variant }), className)}>
      <pre
        className={cn(
          "border-none bg-transparent focus:outline-hidden focus:ring-0 pr-2 pt-2",
          preClassName,
        )}
        {...props}
      />
      <div
        className={cn("flex items-center justify-between gap-2 shrink-0 mt-1", buttonsClassName)}
      >
        {visibleButton}
        {copyButton}
      </div>
    </div>
  );
}

Code.displayName = "Code";

export { Code, codeVariants };
